export default __webpack_public_path__ + "static/media/1.75503ab2.jpg";